import * as actions from './actions';
import { LoadingAction } from '../common/loading-action';
import { ErrorAction } from '../common/error-action';
import { AnalyticsResults } from '@services/analytics/types/analytics-results';
import { AnalyticsQueryTypes } from '@services/analytics/types/analytics-query-enum';
import Filters from '@common/types/artist-analytics/filters';
import { Action } from 'redux';

export class GetArtistAnalytics implements LoadingAction {
  readonly type = actions.GET_ARTIST_ANALYTICS;
  readonly isLoading = true;

  constructor(
    public queryDataType: AnalyticsQueryTypes,
    public artistId?: string,
    public isInitial: boolean = false
  ) {}
}

export class GetArtistAnalyticsSuccess implements LoadingAction {
  readonly type = actions.GET_ARTIST_ANALYTICS_SUCCESS;
  readonly isLoading = false;

  constructor(
    public results: AnalyticsResults,
    public queryDataType: AnalyticsQueryTypes
  ) {}
}

export class GetArtistAnalyticsError implements ErrorAction {
  readonly type = actions.GET_ARTIST_ANALYTICS_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class UpdateAnalyticsTimeframe implements Action {
  readonly type = actions.UPDATE_TIMEFRAME;
  readonly isLoading = false;

  constructor(public start?: number, public end?: number) {}
}

export class ResetArtistAnalytics implements Action {
  readonly type = actions.RESET_ANALYTICS;
}

export class UpdateField<T extends keyof Filters> implements Action {
  readonly type = actions.UPDATE_FIELD;
  readonly isLoading = false;

  constructor(
    public field: T,
    public value?: Filters[T] // public disableAutoSave?: boolean
  ) {}
}

export type ArtistAnalyticsActions =
  | GetArtistAnalytics
  | GetArtistAnalyticsSuccess
  | GetArtistAnalyticsError
  | UpdateAnalyticsTimeframe
  | ResetArtistAnalytics
  | UpdateField<keyof Filters>;
